import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=f9622c92&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=f9622c92&prod&lang=less"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=f9622c92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9622c92",
  null
  
)

export default component.exports